import { type OperationContext, type OperationResult, useMutation } from "urql"

import type {
  Mutation,
  PriceChangeMutationAddPurchasingCostPackageArgs,
  PriceChangeMutationAddSpecialPricePackageArgs,
} from "@/graphql/codegen/graphql"
import { AddPurchasingCostPackageDocument, AddSpecialPriceDocument } from "@/graphql/codegen/graphql"

interface UsePriceChangeReturn {
  addSpecialPricePackage: (
    variables: PriceChangeMutationAddSpecialPricePackageArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "priceChange">, PriceChangeMutationAddSpecialPricePackageArgs>>
  addPurchasingCostPackage: (
    variables: PriceChangeMutationAddPurchasingCostPackageArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "priceChange">, PriceChangeMutationAddPurchasingCostPackageArgs>>
}

export const usePriceChange = (): UsePriceChangeReturn => {
  const [, addSpecialPricePackage] = useMutation<
    Pick<Mutation, "priceChange">,
    PriceChangeMutationAddSpecialPricePackageArgs
  >(AddSpecialPriceDocument)

  const [, addPurchasingCostPackage] = useMutation<
    Pick<Mutation, "priceChange">,
    PriceChangeMutationAddPurchasingCostPackageArgs
  >(AddPurchasingCostPackageDocument)

  return {
    addSpecialPricePackage,
    addPurchasingCostPackage,
  }
}
